import AWS from "aws-sdk";
import * as localforage from "localforage";
import { uploadFileToNubisDriveAPI } from "../apis/uploadFileToNubisDriveAPI";
import { errorHandling } from "./errorHandling";
import { Md5 } from "ts-md5/dist/md5";
import { APP_ENV } from "@/APP_ENV";
// import { downloadFileLink } from "@/apis/announcementApi";

export const s3upload = async (
  dom,
  parentId,
  t,
  successfulText,
  percentCompleted,
  setPercentCompleted,
  onClose,
  setRefreshCapacity,
  reloadTable,
  needMd5 = false, // if need md5
  setReturnValue, // if need get return value about s3path and md5
  filePath, // if need customized filePath
  needCompanyId = true, // if s3path need companyId
  changeName = false, // if need to change name with timestamp
  disableCreate = false, // if need to disable call create api
  setDisabled,
  target,
  extra,
  handleChange
) => {
  // AWS Docs
  // https://docs.aws.amazon.com/AWSJavaScriptSDK/latest/AWS/S3.html
  const files = dom.files;
  const bucketRegion = APP_ENV.REACT_APP_BUCKET_REGION;
  const bucketName = APP_ENV.REACT_APP_BUCKET_NAME;
  const IdentityPoolId = APP_ENV.REACT_APP_IDENTITY_POOL_ID;
  const enableS3Accelerate = JSON.parse(APP_ENV.REACT_APP_AWS_S3_ACCELERATE);

  // init aws setting
  AWS.config.update({
    region: bucketRegion,
    credentials: new AWS.CognitoIdentityCredentials({
      IdentityPoolId: IdentityPoolId
    }),
    httpOptions: {
      timeout: 100000000 * 60 * 1000
    }
  });

  const s3 = new AWS.S3(enableS3Accelerate);

  if (files) {
    let file = files[0];
    if (changeName) {
      Object.defineProperty(file, "name", {
        writable: true,
        value: `${file.name.replace(/\.[^/.]+$/, "")}-${+new Date()}.${file.name
          .split(".")
          .pop()}`
      });
    }
    let fileName = file.name;
    let partSize = 10 * 1024 * 1024; // 10mb per part
    let queueSize = 10; // concurrent queue
    let userData = await localforage.getItem("user");
    let companyId = userData.company_id;

    if (filePath) {
      filePath = `${APP_ENV.REACT_APP_NAME.toLowerCase()}/${filePath}/${
        needCompanyId ? `${companyId}-${userData.company.name}/` : ""
      }${fileName}`;
    } else {
      let companyName = encodeURIComponent(userData.company.name);
      filePath = `${APP_ENV.REACT_APP_NAME.toLowerCase()}/${companyId}-${companyName}/${fileName}`;
    }
    let md5;
    if (needMd5) {
      function getMD5HashFromFile(file) {
        md5 = new Md5().appendByteArray(file).end();
        return md5;
      }

      const reader = new FileReader();
      reader.onload = event => {
        const binary = event.target.result; // this will get an 'arraybuffer'
        // getMD5HashFromFile(Buffer.from(binary)); // Buffer.from returns a buffer for 'md5'
        getMD5HashFromFile(new Uint8Array(binary)); // Buffer.from returns a buffer for 'md5'
      };

      reader.readAsArrayBuffer(dom.files[0]);
    }

    // prettier-ignore
    return s3.upload(
      {
        Bucket: bucketName,
        Key: filePath,
        Body: file
      },
      {
        partSize: partSize,
        queueSize: queueSize
      },
      function(error, data) {
        if (error) {
          if (error.code !== 'RequestAbortedError') {
            errorHandling(error, false);

            // throw exception to stop continue executing
            // throw new awsS3Exception(error);
            throw new Error(error);
          }
          return;
        }

        /**
         * {
         *  Bucket: "fec-s3"
         *  ETag: 845013041f0bdac19d3c3ac173e5dd38-317",
         *  Key: "my-first-bucket-path/macOS Mojave 10.14 Install.dmg", // need this one for create file API's s3_path KEY
         *  Location: "https://fec-s3.s3-accelerate.amazonaws.com/my-first-bucket-path/macOS+Mojave+10.14+Install.dmg"
         * }
         * */
        if (!disableCreate) {

          handleChange({
            name: file.name,
            extension: file.name.split(".").pop(),
            mime_type: file.type,
            size: file.size,
            s3Path: data.Key,
            md5: md5,
            target,
            ...extra
          })

          // 获取当前下载链接，链接需要用的时候请求，有时间限制，存s3Path即可
          // downloadFileLink(encodeURIComponent(data.Key)).then(fileRes => {
          //   console.log(fileRes)
          //
          //   handleChange({
          //     name: file.name,
          //     extension: file.name.split(".").pop(),
          //     mime_type: file.type,
          //     size: file.size,
          //     s3Path: data.Key,
          //     md5: md5,
          //     downloadLink: fileRes.download_link,
          //     target,
          //     ...extra
          //   })
          // })

          // 公告文件上传不需要调用此接口
          uploadFileToNubisDriveAPI(
            data,
            file,
            md5,
            parentId,
            t,
            successfulText,
            onClose,
            setRefreshCapacity,
            reloadTable,
            setReturnValue,
            setDisabled,
            target,
            extra
          );
        }

        if (setReturnValue) {
          setReturnValue({ md5, filePath });
        }
      }
    ).on("httpUploadProgress", function (progress) {
      let uploaded = parseInt((progress.loaded / progress.total) * 100);
      if (uploaded > percentCompleted) {
        setPercentCompleted(uploaded);
      }
    });
  }

  // sham a abort method
  return {
    abort: () => {}
  };
};

export const awsS3Exception = error => {
  return errorHandling(error, false);
};
